<template>
  <div style="background:#01000A; margin-top:-48px;">
    <v-container>
      <div v-for="category in categories" :key="category">
        <v-row style="margin-top:80px;" class="ml-1">
          <h1 class="white--text text-h3 ">{{ category }}</h1>
        </v-row>
        <v-row class="mt-2">
          <v-col
            v-for="item in filterItems(category)"
            :key="item.id"
            cols="6"
            xs="1"
            sm="6"
            md="6"
            xl="4"
            class="mt-5"
          >
            <CatalogueCard :item="item" />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import CatalogueCard from '@/components/CatalogueCard.vue'
import catalogueData from '@/data/scenes.json'
export default {
  components: {
    CatalogueCard
  },
  data() {
    return {
      hover: false,
      items: catalogueData,
      // {
      //   "id": 7,
      //   "name": "goldencity",
      //   "category": "Interactive Experiences",
      //   "gif": false,
      //   "compressed": true,
      //   "title": "Golden City Visionary Design",
      //   "puzzles": false
      // },
      categories: [
        'Innovative Products',
        'Interactive Experiences',
        'Architecture',
        'Embedded Systems',
        'Applications'
      ]
    }
  },
  methods: {
    filterItems(category) {
      return this.items.filter(item => item.category === category)
    }
  }
}
</script>

<style scoped>
.text-h3,
.text-h4,
.text-body-2,
.text-body-1 {
  font-family: 'Overlock' !important;
  text-shadow: 0px 0px 24px rgba(255, 255, 255, 0.88);
}

.text-h5,
.text-h6 {
  font-family: 'Overlock' !important;
  /* line-height: 1.5rem !important; */
}
</style>
